module.exports = {
	"application_form.entripName": "Tadbirkorlik sub’ekti nomi",
	"application_form.invalid_type_id": "Инвалидность",
	"application_form.formError": "Xizmatdan foydalanib bo‘lmadi. Keyinroq urinib ko‘ring.",
	"application_form.phoneError": "Telefon raqamini to‘g‘ri kiriting.",
	"application_form.phoneLabel": "Telefon (+998xxxxxxxxx)",
	"application_form.agreementHint": "Foydalanish <a href={link} id={id} data-toggle={dataToggle} data-target={dataTarget}>qoidalari</a> bilan tanishdim",
	"application_form.answerOnlyElectron": "Murojaatga faqat elektron shaklda javob berilishiga roziman",
	"application_form.answerElectronAndWritten": "Murojaatga qog'oz va elektron shaklda javob berilishiga roziman",
	"application_form.yearError": "To‘g‘ilgan yilingizni to‘g‘ri formatda kiriting: (dd.mm.19xx/20xx)",
	"application_form.emailError": "Тўғри электрон почта манзилини кўрсатинг",
	"application_form.surname": "Familiya",
	"application_form.name": "Ism",
	"application_form.secondName": "Otasining ismi",
	"application_form.fileError": "5 mbdan katta fayl yuklash mumkin emas!",
	"application_form.fileError2": "Bunday formatdagi faylni yuklash mumkin emas!",
	"application_form.captchaError": "Javob noto‘g‘ri. Boshqattan urinib ko‘ring.",
	"application_form.captchaHint": "Rasmdagi raqamlarni kiriting",
	"application_form.region": "Hudud",
	"application_form.district": "Tuman (shahar)",
	"application_form.country": "Davlat",
	"application_form.gender": "Jins",
	"application_form.birthdate": "Tug‘ilgan sana",
	"application_form.isSecret": "Murojaat oshkoraligi",
	"application_form.address": "Manzil",
	"application_form.email": "Elektron pochta",
	"application_form.feedback_email": "Elektron pochta (ixtiyoriy)",
	"application_form.phone": "Telefon",
	"application_form.entrip": "Tadbirkor",
	"application_form.entripHint": "Tadbirkorlik sub’ekti sifatida murojaat qilayotgan bo‘lsangiz ushbu katakchani belgilang",
	"application_form.status": "Maqom",
	"application_form.fileLabel": "Qo‘shimcha fayl",
	"application_form.fileHint": "Qo‘shimcha faylni ko‘rsating <br/>(xajmi  5mb gacha)",
	"application_form.applicationLabel": "Murojaat matni",
	"application_form.applicationHint": "Murojaatingiz tezkor ravishda hal etilishini istasangiz, har bir masala bo‘yicha alohida murojaat yo‘llashingizni hamda mazkur murojaatni lo‘nda, oddiy va ravon tilda bayon etishingizni so‘raymiz!",
	"application_form.sendButton": "Jo‘natish",
	"application_form.notAccepted": "Taqiqlangan fayl",
	"application_form.maxNumberOverflow": "Jami fayllar soni 10 tadan oshmasligi lozim",
	"application_form.uploadFile": "Faylni yuklang",
	"application_form.phoneReal": "Telefon raqami tasdiqlandi!",
	"application_form.getCode": "Kod olish",
	"application_form.enterCode": "Tekshiruv kodini kiriting",
	"application_form.resendCode": "Qayta yuborish",
	"application_form.codeSendTo": "Tekshiruv kodi ushbu raqamga yuborildi",
	"application_form.fileSize": "Faylning hajmi 10 mb dan va jami fayllar soni 10 tadan oshmasligi lozim",
	"application_form.fileUploaded": "Fayl yuklandi",
	"application_form.error": "Xato!",
	"application_form.secretInfo": "Murojaat va murojaatchi to‘g‘risida ma’lumotlarning oshkoraligi",
	"application_form.makhalla": "Mahalla",
	"application_form.man": "Erkak",
	"application_form.woman": "Ayol",
	"application_form.yes": "Ha",
	"application_form.no": "Yo‘q",
	"application_form.showPhone": "Murojaat yo'llash uchun telefon raqamingizni kiriting.",
	"application_form.unknownError": "Xatolik yuz berdi!",
	"application_form.applicationSuccess": "Sizning murojaatingiz {title}ga muvaffaqiyatli yuborildi!",
	"application_form.applicationAlreadySuccess": "Siz bugun aynan ushbu mazmundagi murojaatni yubordingiz. Iltimos avvalgi yuborgan murojaatingiz javobini kuting!",
	"application_form.pleaseSave": "Diqqat!!! Quyidagi malumotlarni saqlab oling",
	"application_form.applicationNo": "Murojaat raqami",
	"application_form.applicationToken": "Tekshirish kodi",
	"application_form.authority": "Tashkilot nomi",
	"application_form.request_no": "Murojaat raqami",
	"application_form.note_title": "Shaxsingizni tasdiqlovchi maʼlumotlarni kiriting",
	"application_form.note_warning": "Siz tomondan kiritilgan shaxsga doir maʼlumotlar uchinchi shaxslarga oshkor etilmaydi va tarqatilmaydi!",
	"application_form.note_text": "Shaxsni tasdiqlovchi maʼlumotlarni kiritish quyidagi afzalliklarga ega:",
	"application_form.note_list_item_one": "murojaat yuborish shaklining ko‘plab qismlari avtomatik ravishda to‘ldiriladi",
	"application_form.note_list_item_two": "kiritilgan murojaat nomingizda saqlanadi va uni istalgan paytda id.egov.uz xizmati orqali tizimga kirib topishingiz mumkin bo‘ladi",
	"application_form.note_list_item_three": "murojaatni asossiz ravishda ko‘rmasdan qoldirish holatlarining oldi olinadi",
	"application_form.preliminary_form_title": "Shaxsni tasdiqlovchi hujjat maʼlumotlari*:",
	"application_form.passport_series": "Seriyasi",
	"application_form.passport_number": "Raqami",
	"application_form.passport_helper_text": "*Shaxsni tasdiqlovchi hujjat sifatida fuqarolik pasporti, ID-karta va xorijga chiqish pasportidan foydalanish mumkin",
	"application_form.dd_mm_yy": "kun | oy | yil",
	"application_form.captcha_label": "Rasmdagi raqamni kiriting",
	"application_form.preliminary_form_link": "Bu bosqichni o‘tkazib yuborish",
	"application_form.captcha": "Rasmdagi misolning javobini kiriting",
	"application_form.close": "Orqaga",
	"application_form.full_name": "F.I.O",
	"application_form.feedback_label": "Mahallangiz topilmadimi?",
	"application_form.choose_mahalla": "Mahallangizni tanlang...",
	"application_form.feedback_title": "Qayta aloqa",
	"application_form.feedback_alert": "Sizning xabaringiz muvaffaqiyatli yuborildi!",
	"application_form.needed_field": "\"{attribute}\" ma'lumotini to'ldiring",
	"application_form.is_agree": "Masulyat bilan tanishish",
	"application_form.juridical_tin": "ИНН",
	"application_form.get_tin": "Получить данные по ИНН",
	"application_form.check_tin": "Проверка ИНН",
	"application_form.passport": "Паспорт, ID-карта или загранпаспорт гражданина",
	"application_form.birth_certificate": "Свидетельство о рождении",
	"application_form.tin_confirmed": "Действительность ИНН подтверждена",
	"application_form.tin_rejected": "ИНН не действителен",
	"application_form.cert_helper_text": "Укажите серию и номер свидетельства о рождении",
	"apps.appeals.appTitle": "Мурожаат йўллаш турлари",
	"apps.appeals.goToRecept": "Яшаш жойингиз бўйича Ўзбекистон Республикаси Президенти Халқ қабулхонасига ташриф буюринг",
	"apps.appeals.callCenter": "<span>1000</span> ёки <span>0-800-210-00-00</span><br>телефон рақамига қўнғироқ қилинг<br>ва ўз масалангизни оғзаки баён қилинг",
	"apps.appeals.sendAppeal": "Виртуал қабулхонага мурожаат юборинг",
	"apps.Authorities.showAll": "Barcha yo‘nalishlar",
	"apps.Authorities.close": "Orqaga",
	"apps.Authorities.step": "Bo‘lim",
	"apps.Authorities.noData": "Ma’lumot topilmadi",
	"apps.Authorities.searchBtn": "Izlash",
	"apps.Authorities.emailShort": "el. pochta",
	"apps.Authorities.phone": "Telefon",
	"apps.Authorities.phoneShort": "tel.",
	"apps.Authorities.website": "Veb-sayt",
	"apps.Authorities.websiteShort": "veb-sayt",
	"apps.Authorities.fax": "Faks",
	"apps.Authorities.faxShort": "faks",
	"apps.Authorities.formLabel": "Murojaat yuborish",
	"apps.Authorities.appTitle": "Vazirlik va idora rahbarlarining fuqarolarni<br/> qabul qilish jadvali va ularga murojaat yuborish",
	"apps.Authorities.firstUsellessBtn": "Fuqarolarni qabul qilish jadvali",
	"apps.Authorities.secondUselessBtn": "Davlat organlariga murojaat yuborish",
	"apps.Authorities.opt": "Yo‘q",
	"apps.Authorities.formInfo": "Tashkilot virtual qabulxonasiga murojaat yuborish",
	"apps.Authorities.fio": "F.I.O.",
	"apps.Authorities.position": "Lavozim",
	"apps.Authorities.receptDays": "Qabul qilish grafigi",
	"apps.Authorities.orgAdress": "Tashkilot pochta manzili",
	"apps.Authorities.phone2": "Tashkilot raqami",
	"apps.Authorities.email2": "Elektron pochta manzili",
	"apps.Authorities.days": "Hafta kunlari",
	"apps.Authorities.time": "Vaqti",
	"apps.Authorities.authFirstTab": "Fuqarolarni qabul qilish<br>jadvali va manzil",
	"apps.Authorities.authSecondTab": "Funksiya va vazifalar",
	"apps.Authorities.authThirdTab": "Murojaat yuborish",
	"apps.Authorities.functions": "Funksiyalar",
	"apps.Authorities.tasks": "Vazifalar",
	"apps.Authorities.error": "Xato!",
	"apps.Authorities.printButton": "Chop etish",
	"apps.Authorities.unknownError": "Xatolik yuz berdi!",
	"apps.consulates.appName": "O‘zbekistonning chet davlatlardagi konsullik muassasalari",
	"apps.consulates.aLabel": "O‘zbekistonning chet davlatlardagi konsullik muassasalari",
	"apps.consulates.bLabel": "Chet davlatlardagi fuqarolar uchun murojaat yo‘llash formasi",
	"apps.harassment-message.attentionTitle": "DIQQAT!",
	"apps.harassment-message.attentionText": "Agar Siz Virtual qabulxonaga murojaat qilganingizdan so'ng ta'qibga duchor bo'lsangiz bu haqida darhol xabar bering",
	"apps.harassment-message.attentionBtn": "Ta'qib haqida xabar",
	"apps.Qa.showAll": "Barcha yo‘nalishlar",
	"apps.Qa.appTitle": "O‘zingizni qiziqtirgan savolga javob toping",
	"apps.Qa.close": "Orqaga",
	"apps.Qa.step": "Bo‘lim",
	"apps.Qa.noData": "Ma’lumot topilmadi",
	"apps.Qa.searchBtn": "Izlash",
	"apps.Qa.qaHint": "Agar savolingizga to‘liq javob olmagan bo‘lsangiz quyidagi organlarga murojaat qilishingiz mumkin:",
	"apps.Qa.watched": "Ko‘rilgan",
	"apps.Receptions.showAll": "Barcha yo‘nalishlar",
	"apps.Receptions.uzbekistan": "O‘zbekiston Respublikasi",
	"apps.Receptions.close": "Orqaga",
	"apps.Receptions.step": "Bo‘lim",
	"apps.Receptions.noData": "Ma’lumot topilmadi",
	"apps.Receptions.searchBtn": "Izlash",
	"apps.Receptions.address": "Manzil",
	"apps.Receptions.email": "Elektron pochta",
	"apps.Receptions.phone": "Telefon",
	"apps.Receptions.website": "Veb-sayt",
	"apps.Receptions.fax": "Faks",
	"apps.Receptions.appTitle": "Xalq qabulxonalarining manzillari",
	"apps.Receptions.recpCount": "Qabulxonalar soni",
	"apps.Receptions.trsPhone": "ishonch telefoni",
	"apps.Receptions.contacts": "Kontaktlar",
	"apps.Receptions.appeal": "Shikoyat qilish",
	"apps.Receptions.more": "Batafsil",
	"apps.Receptions.onMap": "Xaritada",
	"apps.step": "Bo‘lim",
	"apps.mainFormTitle": "O‘zbekiston Respublikasi Prezidenti Virtual Qabulxonasi",
	"fileSizeValidation": "«{file_name}» faylingiz hajmi katta. Yuklanayotgan faylning hajmi 10 mb dan oshmasligi lozim"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/fr.json
// module id = 928
// module chunks = 0